import script from "./TextStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TextStylePanel.vue?vue&type=style&index=0&id=4cf37a85&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf37a85"]])

export default __exports__